export default __webpack_public_path__ + "static/media/iphone-dark.38f3bb00.png";